import { Box, Grid, TableCell, TableRow, Typography } from "@mui/material"
import FollowUpApi from "api/follow-up.api"
import TableCustom from "component/Table/TableCustom"
import { ChipStatus } from "component/Treatments/TxInformationBox"
import { colors } from "constants/theme"
import _ from "lodash"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { numberFormat } from "utils/app.utils"

interface CourseHistoryTableProps {
    patientId: number
    patient?: any
}

export default function CourseHistoryTable(props: CourseHistoryTableProps) {
    const { t, i18n } = useTranslation()
    const [courseHistory, setCourseHistory] = useState([])
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(5)
    const [rowCount, setRowCount] = useState(0)

    const loadData = async () => {
        if (props.patient?.patientTreatmentCourseId) {
            await FollowUpApi.findUseCourse({ page: page, pageLimit: pageLimit }, props.patient?.patientTreatmentCourseId).then((resp) => {
                setCourseHistory(resp.data)
                setRowCount(resp.headers['x-total'])
            })
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const headCells = [
        { id: 'no', disablePadding: false, label: 'ลำดับ' },
        { id: 'detail', disablePadding: false, label: 'รายละเอียด' },
        { id: 'action', disablePadding: false, label: 'สถานะ' },
    ]



    const renderData = (objData: any, no: number) => {
        const index = page * pageLimit - pageLimit + no + 1
        const renderLabel = (type: 'label' | 'background') => {
            let status = t('TX_INFORMATION.STATUS.PENDING')
            let bg = colors.memberRanking.rankingGold
            if (objData?.status === 'PENDING') {
                status = t('TX_INFORMATION.STATUS.PENDING')
                bg = colors.memberRanking.rankingGold
            } else if (objData?.status === 'CANCEL') {
                status = t('ยกเลิกคอร์ส')
                bg = colors.themeThirdColor
            }
            else if (objData?.status === 'CLOSE') {
                status = t('TX_INFORMATION.STATUS.CLOSE')
                bg = colors.disabledGray
            } else if (objData?.status === 'DONE') {
                status = t('TX_INFORMATION.STATUS.DONE')
                bg = colors.sky
            } else {
                status = t('TX_INFORMATION.STATUS.IN_PROGRESS')
                bg = colors.themeMainColor
            }
            // else if (_.every(objData?.arrayTable, { status: 'DONE' }) || props.status === 'DONE') {
            //     status = t('TX_INFORMATION.STATUS.DONE')
            //     bg = colors.sky
            // }
            // else if (_.some(treatments.summeryTreatments, (tr) => _.some(props.arrayTable, { id: tr.refId })) || _.some(props.arrayTable, { status: 'DONE' })) {
            //     status = t('TX_INFORMATION.STATUS.IN_PROGRESS')
            //     bg = colors.themeMainColor
            // }

            return type === 'label' ? status : bg
        }
        return (
            <>
                <TableRow>
                    <TableCell align="center" scope="row">
                        <Typography>{index}</Typography>
                    </TableCell>
                    <TableCell align="left" scope="row">
                        <Grid container>
                            <Grid xs={4}> <Typography>ชื่อคอร์ส</Typography></Grid>
                            <Grid xs={8}><Typography>{objData?.treatmentCourseName}</Typography></Grid>
                            <Grid xs={4}> <Typography>โดย</Typography></Grid>
                            <Grid xs={8}><Typography>{objData?.updatedBy}</Typography></Grid>
                            <Grid xs={4}> <Typography>จำนวนคงเหลือ</Typography></Grid>
                            <Grid xs={8}><Box display="flex" justifyContent="row" alignItems="center">
                                <Typography>{objData?.balance}/{objData?.totalQty} {t('UNIT.TERMS')}</Typography>
                            </Box></Grid>
                            <Grid xs={4}> <Typography>ค่าคอร์สทั้งหมด</Typography></Grid>
                            <Grid xs={8}><Typography>{numberFormat(objData?.totalPrice)}</Typography></Grid>
                            <Grid xs={4}> <Typography>จ่ายแล้ว</Typography></Grid>
                            <Grid xs={8}><Typography>{numberFormat(objData?.paid)}</Typography></Grid>
                            <Grid xs={4}> <Typography>คงเหลือ</Typography></Grid>
                            <Grid xs={8}><Typography>{numberFormat(objData?.totalPrice - objData?.paid)}</Typography></Grid>
                            <Grid xs={4}> <Typography>รายการหัตถการ</Typography></Grid>
                            <Grid xs={8}>{_.map(objData?.patientTreatmentCourseItems, (item) => (<Typography>{item?.itemName}</Typography>))}</Grid>
                        </Grid>
                    </TableCell>
                    <TableCell align="left" scope="row">
                        <ChipStatus
                            className="ml-1"
                            style={{ backgroundColor: renderLabel('background') }}
                            label={renderLabel('label')}
                            size="small" />
                    </TableCell>
                </TableRow>
            </>
        )
    }

    return (
        <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={'ASC'}
            sortBy={''}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={_.map(courseHistory, (topic, index: number) => {
                return renderData(topic, index)
            })}
            textEmptyData={t('ยังไม่มีข้อมูล')}
            onSort={() => {
                return
            }}
            setPageLimit={(e) => setPageLimit(e)}
            setPage={(e) => setPage(e)}
            maxHeight={500}
            overflowY="auto"
        />
    )
}